export const getCouponTickerMessage = (coupon) => {
  const custom = String(coupon?.tickerMessage || '').trim();
  if (custom) return custom;

  const code = String(coupon?.code || '').trim().toUpperCase() || 'COUPON';
  const value = Number(coupon?.value || 0);
  const saving = coupon?.type === 'percent' ? `${value}% OFF` : `₹${value} OFF`;
  const minimum = Number(coupon?.minOrder || 0);
  return `Use ${code} — ${saving}${minimum > 0 ? ` on orders above ₹${minimum}` : ''}`;
};
